import { QuestionV3ControlTypes } from './enum';
import { QuestionBaseV3 } from './question-base';

export class ButtonQuestionV3 extends QuestionBaseV3 {
  controlType = QuestionV3ControlTypes.BUTTON;
  label: string;
  target?: string;
  href?: string;

  constructor(options: any = {}) {
    super(options);
    this.label = options['label'] || '';
    this.target = options['target'];
    this.href = options['href'] || options['src'];
  }
}
